module.exports = __webpack_public_path__ + "static/media/img_intgration_partner_03.ad6a3ec6.png";